import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Camera, Eye, EyeOff, LogIn } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const PhotographerLogin = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    
    try {
      const res = await axios.post(`${API}/photographers/login`, formData);
      localStorage.setItem("photographer_token", res.data.token);
      localStorage.setItem("photographer_user", JSON.stringify(res.data.photographer));
      navigate("/photographer/portal");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4" data-testid="photographer-login">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <Camera className="w-12 h-12 text-orange-500 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-white mb-2">Photographer Portal</h1>
          <p className="text-zinc-500">Sign in to manage your galleries</p>
        </div>

        {error && (
          <div className="bg-red-500/10 border border-red-500/30 text-red-500 px-4 py-3 mb-6 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-zinc-900/50 border border-white/5 p-6 space-y-4">
          <div>
            <label className="block text-sm text-zinc-400 mb-1">Username</label>
            <input
              type="text"
              required
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              className="w-full px-4 py-3 bg-black border border-white/10 text-white focus:border-orange-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm text-zinc-400 mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="w-full px-4 py-3 bg-black border border-white/10 text-white focus:border-orange-500 focus:outline-none pr-12"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-white"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-orange-500 text-black font-bold hover:bg-orange-400 disabled:opacity-50"
          >
            {submitting ? (
              <div className="w-5 h-5 border-2 border-black/30 border-t-black rounded-full animate-spin" />
            ) : (
              <>Sign In <LogIn className="w-4 h-4" /></>
            )}
          </button>
        </form>

        <p className="text-center text-zinc-600 text-sm mt-6">
          <Link to="/" className="text-zinc-500 hover:text-white">
            ← Back to Home
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PhotographerLogin;
